import { render } from "./Team_operation.vue?vue&type=template&id=32a75165&scoped=true"
import script from "./Team_operation.vue?vue&type=script&lang=js"
export * from "./Team_operation.vue?vue&type=script&lang=js"

import "./Team_operation.vue?vue&type=style&index=0&id=32a75165&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32a75165"

export default script